import React from "react";
import { styled } from "@mui/material/styles";
import logo from "../assets/logo.png";

export const Logo = () => {
  const CustomizedLogo = styled("div")`
    width: 100%;
    height: 152px;
    margin-bottom: 20px;

    background: url(${logo});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    flex: none;
    order: 0;
    flex-grow: 0;
    :hover {
      color: #2e8b57;
    }
  `;

  return <CustomizedLogo />;
};
